
import { useLanguage } from '../../../contexts/LanguageContext';

export default function About() {
  const { t } = useLanguage();

  const stats = [
    { number: '20+', labelKey: 'about.stat1' },
    { number: '200+', labelKey: 'about.stat2' },
    { number: '50+', labelKey: 'about.stat3' },
    { number: '1M+', labelKey: 'about.stat4' }
  ];

  return (
    <section id="about" className="py-24 px-6 bg-white/5 backdrop-blur-sm">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <div className="flex items-center gap-2 mb-6">
              <div className="w-2 h-2 rounded-full bg-[#ff6b4a]"></div>
              <span className="text-[#f5f1e8]/70 text-sm font-medium uppercase tracking-wider">{t('about.badge')}</span>
            </div>
            
            <h2 className="text-4xl lg:text-5xl font-serif font-bold text-white mb-6">
              {t('about.title')}
            </h2>
            
            <p className="text-[#f5f1e8]/80 text-lg leading-relaxed mb-6">
              {t('about.p1')}
            </p>
            
            <p className="text-[#f5f1e8]/80 text-lg leading-relaxed mb-8">
              {t('about.p2')}
            </p>

            <div className="grid grid-cols-2 gap-6 mb-8">
              {stats.map((stat, index) => (
                <div key={index} className="text-center lg:text-left">
                  <div className="text-4xl font-bold text-[#ff6b4a] mb-2">{stat.number}</div>
                  <div className="text-[#f5f1e8]/70">{t(stat.labelKey)}</div>
                </div>
              ))}
            </div>

            <button className="px-8 py-4 bg-transparent border-2 border-[#f5f1e8] text-[#f5f1e8] rounded-lg font-medium hover:bg-[#f5f1e8]/10 transition-all duration-300 whitespace-nowrap cursor-pointer">
              {t('about.cta')}
            </button>
          </div>

          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl h-96 w-full">
              <img 
                src="https://readdy.ai/api/search-image?query=diverse%20team%20of%20environmental%20scientists%20and%20data%20analysts%20collaborating%20in%20modern%20office%2C%20people%20working%20together%20on%20computers%20with%20data%20visualizations%2C%20professional%20workplace%20with%20natural%20lighting%2C%20teamwork%20in%20conservation%20technology%2C%20warm%20collaborative%20atmosphere&width=800&height=600&seq=about-001&orientation=landscape"
                alt="Our Team"
                className="w-full h-full object-cover object-top"
              />
            </div>
            
            <div className="absolute -bottom-8 -right-8 bg-[#1a4d2e]/90 backdrop-blur-sm rounded-2xl p-8 max-w-sm border border-white/10">
              <p className="text-[#f5f1e8] text-lg font-serif italic leading-relaxed">
                {t('about.quote')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
